import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {
  private FaqFilter:any;
  private isgraybackground:boolean=false;
private FaqList:any=
[
 {
  Question:"How do I find a specific call?",
  Ans:"Use the filter tools available at the top of the grid, don’t forget to click the GO button to launch your filters."
 },
 {
  Question:"How do I allocate a call?",
  Ans:"You allocate a call by clicking on the BUS or PVT icons next to the number you want to allocate."
 },
 {
  Question:"What is the difference between a private and business allocation?",
  Ans:"A private allocation will not be added to an account and therefore not billed. A business allocation will be attached to an account."
 },
 {
  Question:"What is a billed and unbilled business call?",
  Ans:"A billed call will be billed to the account selected. An unbilled call will display in the client’s account but have a zero value."
 },
 {
  Question:"My unallocated call has disappeared",
  Ans:"Make sure to switch all filters off by clicking the RESET button above the grid."
 },
 {
  Question:"Why do I only see calls for one number?",
  Ans:"You have clicked on the group call icon. To view all calls, click on the phone icon in the grid or simply click the RESET button above the grid."
 },
 {
  Question:"I’ve allocated a call by mistake, how can I fix it?",
  Ans:"Currently it is not possible to Unallocate a call."
 }
 ,
 {
  Question:"I need more help",
  Ans:"Please read our manual that is available on this page for download."
 }
 
]
  constructor() { }

  ngOnInit() {
    if(localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor"))
    {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground=true;
    }
  }
  DownloadFile()
  {
    //window.open('/assets/doc/RevocoTelephony.pdf', '_blank');
    document.getElementById("downloadfile").click();
  }

}
